'use client';

import Icon from './Icon';
import svg from 'sprites/google-play.svg';

export default function IconGooglePlay({
  className = 'w-3.5 h-4 fill-graphite stroke-none'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
